import React, { useState, useEffect } from 'react';
import { useLang } from '../../../_LangContext';
import { UISelect } from '../basic';

const UISelectLang = () =>
{
	const { lang, changeLang, getAvailableLanguages } = useLang();
	const [options, setOptions] = useState([]);

	useEffect(() =>
	{
		const availableLanguages = getAvailableLanguages();
		const newOptions = availableLanguages.map(langItem => (
		{
			value: langItem.code,
			label: langItem.name.toUpperCase(),
		}
		));
		setOptions(newOptions);
	},
	[lang, getAvailableLanguages]);

	const onChange = selectedOption =>
	{
		changeLang(selectedOption.value);
	};

	return (
		<UISelect
			className="lang"
			options={options}
			value={lang}
			onChange={onChange}
		/>
	);
};

export default UISelectLang;